import { useCallback, useRef } from 'react';

/**
 * Ticket #91 — gestionnaire d'événement à identité stable qui appelle toujours
 * la dernière version de `fn`. Permet de mémoïser les lignes de grille
 * (`React.memo`) sans les re-rendre à chaque rendu du parent pour de simples
 * callbacks recréés. À réserver aux gestionnaires d'événement : une fonction
 * dont le RÉSULTAT influe sur le rendu doit garder de vraies dépendances.
 */
export function useStableHandler(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args) => ref.current(...args), []);
}
